import React, { useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Plus } from 'lucide-react';
import { ScrollableModal } from '../../components/ui/ScrollableModal';
import FormField from '../../components/forms/FormField';
import SelectDropdown from '../../components/ui/SelectDropdown';

export default function AssignRepositoryModal({
  isOpen,
  onClose,
  assignSaving,
  assigningRepo,
  selectedStreamId,
  onSelectedStreamIdChange,
  selectedProjectId,
  onSelectedProjectIdChange,
  streams,
  streamProjects,
  loadingStreamProjects,
  onConfirm,
}: any) {
  const { control, reset } = useForm({
    defaultValues: { streamId: '', projectId: '' },
  });

  useEffect(() => {
    if (isOpen) {
      reset({ streamId: selectedStreamId || '', projectId: selectedProjectId || '' });
    }
  }, [isOpen, selectedStreamId, selectedProjectId, reset]);

  return (
    <ScrollableModal
      isOpen={isOpen}
      onClose={onClose}
      title="Connect repository"
      icon={<Plus className="w-5 h-5 text-vivid-red" />}
      disableClose={assignSaving}
      footer={
        <>
          <button
            type="button"
            onClick={onClose}
            disabled={assignSaving}
            className="btn-secondary-mdl"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={assignSaving || !selectedProjectId}
            className="btn-primary-mdl border-2 border-transparent"
          >
            {assignSaving ? 'Connecting…' : 'Connect'}
          </button>
        </>
      }
    >
      <div className="space-y-4">
        {assigningRepo && (
          <p className="text-sm text-slate-400">
            Connect <strong className="text-slate-100">{assigningRepo.fullName}</strong> to a
            project.
          </p>
        )}
        <FormField
          id="assign-stream"
          label="Stream"
          labelClassName="block text-sm font-medium text-slate-300 mb-1"
        >
          <Controller
            name="streamId"
            control={control}
            render={({ field }) => (
              <SelectDropdown
                id="assign-stream"
                value={field.value}
                onChange={(v) => {
                  field.onChange(v);
                  onSelectedStreamIdChange(v);
                }}
                placeholder="Select a stream…"
                options={streams.map((s) => ({ value: s.id, label: s.name }))}
              />
            )}
          />
        </FormField>
        <FormField
          id="assign-project"
          label="Project"
          labelClassName="block text-sm font-medium text-slate-300 mb-1"
        >
          <Controller
            name="projectId"
            control={control}
            render={({ field }) => (
              <SelectDropdown
                id="assign-project"
                value={field.value}
                onChange={(v) => {
                  field.onChange(v);
                  onSelectedProjectIdChange(v);
                }}
                disabled={!selectedStreamId || loadingStreamProjects}
                placeholder={
                  !selectedStreamId
                    ? 'Select a stream first'
                    : loadingStreamProjects
                      ? 'Loading…'
                      : streamProjects.length === 0
                        ? 'No projects in this stream'
                        : 'Select a project'
                }
                options={streamProjects.map((p) => ({ value: p.id, label: p.name }))}
              />
            )}
          />
        </FormField>
      </div>
    </ScrollableModal>
  );
}
